import formApi from "@/api/form";
import { FormState } from "@/shared/interfaces";
import { objectFromFlatQuestions } from "@/shared/helpers";
import {Section} from '@/shared/interfaces';
import router from '@/router';
import _ from 'lodash';
import * as moment from 'moment';

const state: FormState = {
  form: {
    sections: {}
  },
  formAnswers: {
    userAnswers: []
  },
  formError: {},
  branches: {},
  branchesError: {}
};

const getters = {
  getForm(state: FormState, getters: any) {
    return state.form;
  },
  getGeneralInformationAnswers(state: FormState, getters: any) {
    return state.formAnswers;
  },
  getAnswers(state: FormState, getters: any) {
    return state.formAnswers.userAnswers;
  },
  getBranches(state: FormState, getters: any) {
    return state.branches;
  }
};

const actions = {
  async fetchForm({ commit }:{commit: Function}, { branchId, answers}: {branchId: string, answers: any}) {

    try {
      const response: any = await formApi.getForm(branchId);
      const sections: Section[] = objectFromFlatQuestions(response['data']);
      let defaultAnswers;

      if (typeof answers === 'undefined' || answers.length === 0) {
        defaultAnswers = response.data.map((el:any) => {
          return {
            questionId: el.id,
            answerId: el.answers.filter((el:any) => el.isDefaultAnswer ? el.id : null)[0].id
          }
        })
      } else {
        defaultAnswers = answers.map((el: any) => {
          return {
            questionId: el.questionId,
            answerId: el.answerId
          }
        })
      }

      commit("setFormUserAnswers", defaultAnswers);
      commit("setForm", sections);
    } catch (e) {
      commit("setFormError", e);
    }
  },

  async fetchBranches({ commit }: { commit: Function }) {
    try {
      const response = await formApi.getBranches();

      commit("setBranches", response.data);
    } catch (e) {
      commit("setReportsError");
    }
  },

  async postForm(context: any, payload: any) {
    try {
      context.commit("setDateInUTC");
      const response = await formApi.sendForm(context.state.formAnswers);

      if(response.data.isSuccess === true) {
        context.commit("clearAnswers");
        router.push(`/report/generated/`);
      }
    } catch (e) {
        context.commit("setReportsError");
    }
  },

  updateUserAnswers(context: any,  answer: any) {
      context.commit("setUpdatedUserAnswers", answer);
  }
};

const mutations = {
  setForm: (state: FormState, form: object) => (state.form = form),
  setFormGeneralInformationAnswers: (state: FormState, answers: object) => {
      state.formAnswers = answers,
      state.formAnswers = { ...state.formAnswers }
  },
  setFormUserAnswers: (state: FormState, userAnswers: object[]) => {
      state.formAnswers = {
        ...state.formAnswers,
        userAnswers
     }
  },
  setUpdatedUserAnswers: (state: FormState, answerToUpdate: any) => {
    const userAnswers = [...state.formAnswers.userAnswers];
    const { questionId, answerId } = answerToUpdate;
    userAnswers.map(el => el.questionId === questionId ? el.answerId = answerId : el.answerId);

    state.formAnswers.userAnswers = userAnswers;
  },
  setFormError: (state: FormState, error: object) => (state.formError = error),
  setBranches: (state: FormState, branches: object) => (state.branches = branches),
  setBranchesError: (state: FormState, branchesError: object) => (state.branchesError = branchesError),
  setDateInUTC: (state: FormState) => state.formAnswers.referenceDateDebtorPortfolio = moment.utc(state.formAnswers.referenceDateDebtorPortfolio).format(),

  clearAnswers: (state: FormState) => {
    state.formAnswers = [];
    state.formAnswers.nominalCarryingAmount = 0;
    state.formAnswers.nominalCarryingAmountDebtorPortfolio = 0;
  },
  clearForm: (state: FormState) => state.form = {}
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
